import {
    NEW_VERSION_POPUP_ID as SourceNEW_VERSION_POPUP_ID
} from 'SourceComponent/NewVersionPopup/NewVersionPopup.config';

// TODO: implement NEW_VERSION_POPUP_ID
export const NEW_VERSION_POPUP_ID = SourceNEW_VERSION_POPUP_ID;
